module.exports = __webpack_public_path__ + "media/audio34.36d29923.mp3";